import { render, staticRenderFns } from "./itemcustomergroupfrm.vue?vue&type=template&id=17cfc458"
import script from "./itemcustomergroupfrm.vue?vue&type=script&lang=js"
export * from "./itemcustomergroupfrm.vue?vue&type=script&lang=js"
import style0 from "./itemcustomergroupfrm.vue?vue&type=style&index=0&id=17cfc458&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports